import { Component, OnInit, Inject } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { MAT_DIALOG_DATA } from '@angular/material';
import * as _ from 'lodash';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { Subscription, Observable } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';


@Component({
  selector: 'app-add-supplier-customer',
  templateUrl: './add-supplier-customer.component.html',
  styleUrls: ['./add-supplier-customer.component.scss']
})
export class AddSupplierCustomerComponent implements OnInit {
  isLoading: boolean;
  customerData = [];

  constructor(private _modalService: ModalService, @Inject(MAT_DIALOG_DATA) public data: any,
    private _dropdownService: DropdownService, private _flashMessage: FlashMessageService, private _customerSvc: CustomerService) { }
  public selected: any;

  ngOnInit() {
    this._customerSearchSetup();
    this.generateCustomerList();
  }

  /**
   * @param
   * gets customers list , on seelct sends data to update xref
   */

  generateCustomerList() {
    this.isLoading = true;
    this._customerSvc.getCustomers().then(customersList => {
      customersList.map(customer => {
        if (customer['name'] && customer['erpCustomerID']) {
        const customerDetails = {
          custname: _.get(customer, 'name', null),
          erpCustomerID: _.get(customer, 'erpCustomerID', null)
        };
        this.customerData.push(customerDetails);
      }
      });
      this.selected = this.customerData[0].erpCustomerID;
      this.isLoading = false;
    });
  }

  onCancel() {
    this._modalService.close();
  }

  onSave() {
    // handle duplicate xref
    if (this.data.map(function (xref) { return xref.erp_customer_id; }).indexOf(this.selected) > -1) {
      this._flashMessage.updateMessage('Customer Already Exists');
    } else {
      const customer = [{ erpCustomerID: this.selected, id: this.selected, custname: this.customerSearch.split('-')[0].trim() }];
      this._modalService.close(customer);
    }
  }

  private _searchSubscription: Subscription;
  public customerDD: any[] = [];
  public customerSearch: string = '';

  /**
 * Setup Customer search
 * Observes the element with id "customer"
 * Waits 500 milliseconds before it sends filter request to back end
 */
  private _customerSearchSetup(): void {
    this._searchSubscription = Observable.fromEvent(document.getElementById('customerSearch'), 'input').pipe(
      map((e: KeyboardEvent) => {
        let element = e.target as HTMLInputElement;
        let value = element.value;
        return value;
      }),
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((searchText: any) => {
      if (!searchText || !searchText.trim()) {
        this.customerDD = [];
        this.customerSearch = null;
      } else {
        this._dropdownService.getDropdown(searchText, 'CUSTOMER').subscribe((result: any[]) => {
          this.customerDD = result;
        }, () => {
          this._flashMessage.updateMessage('Failed to load customers.')
        });
      }

    });
  };

  /**
   * Update fields on select customer dropdown
   * @param customerName
   * @param customerId
   */
  public selectCustomer(customerName: string, customerId: string): void {
    this.selected = customerId;
    this.customerSearch = `${customerName} - ${customerId}`;
    this.customerDD = [];
  }

  ngOnDestroy(): void {
    this._searchSubscription.unsubscribe();
  }

}
